import { number, struct } from 'io-ts/Decoder';

import { Line } from '../../../../ui/geometry/Line';

export const Request = struct({
	scale: number,
	path: Line,
});
